import { render, staticRenderFns } from "./IconRightChevron.vue?vue&type=template&id=0cc5ed2a&"
import script from "./IconRightChevron.vue?vue&type=script&lang=js&"
export * from "./IconRightChevron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports